<template>
<a :href="href ?? '#'" @click="clicked">
    <li class="nav-item" style='padding-left:16px;'>
        <img v-if='icon' :src='icon' style='width: 24px; margin-left:0px; margin-right: -16px' alt='menu icon' />
        <span class="name-li">{{name}}</span>
        
    </li>
</a>
</template>

<script>

export default { 
    name: "menu-item",
    data: function() { 
        return {
        }
    },
    props: ["href", "name", "icon", "navigate"],
    methods: {
        clicked(e) {
            if (!this.navigate) {
                e.preventDefault();
            }
            e.stopPropagation(); // "Edit course" should not trigger "Click" event on menu, which causes it to expand
            this.$emit('select');
        },
    }
}
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
        color: white;
    }
    .nav-item {
        img {
            position: relative;
            bottom: 1px;
        }
    }
    .nav-item:hover {
        opacity: 0.8;
    }
</style>